/**
 * SaasVendorLockOutlet — the per-vendor licence gate of the unified /saas-ai
 * module.
 *
 * Every AI provider is its own module (openai, anthropic, cursor,
 * google_antigravity). The route itself is not module-gated, so the vendor
 * switcher above stays usable; when the ACTIVE vendor is not licensed, the
 * page area shows the lock screen and the page is never mounted (no fetch).
 */
import React from 'react';

import ModuleLocked from '../licensing/ModuleLocked';
import PageLoadingFallback from '../common/PageLoadingFallback';
import useModuleLicense from '../../licensing/useModuleLicense';
import { useSaasVendor } from '../../contexts/SaasVendorContext';
import { SAAS_VENDORS } from '../../services/vendor/vendorStore';

const moduleOfVendor = (vendorId) => (SAAS_VENDORS.find((v) => v.id === vendorId) || {}).module || vendorId;

export default function SaasVendorLockOutlet({ children }) {
  const { vendor } = useSaasVendor();
  const license = useModuleLicense();
  const module = moduleOfVendor(vendor);
  if (!license.isLicensed(module)) {
    return license.ready ? <ModuleLocked module={module} /> : <PageLoadingFallback />;
  }
  return children;
}
